import axios from 'axios';

const ROOT = 'api/v1';

const LogLinkApi = {
  getParticipants({ studyId, ssuPatientId, itemGroupTemplateId, itemGroupTemplateVersionId, rowId }) {
    return axios.get(
      `${ROOT}/studies/${studyId}/patients/${ssuPatientId}/item-groups/${itemGroupTemplateId}/${itemGroupTemplateVersionId}/logs/rows/${rowId}/participants`
    );
  },
  linkParticipants({ studyId, ssuPatientId, itemGroupTemplateId, itemGroupTemplateVersionId, rowId, participants }) {
    return axios.post(
      `${ROOT}/studies/${studyId}/patients/${ssuPatientId}/item-groups/${itemGroupTemplateId}/${itemGroupTemplateVersionId}/logs/rows/${rowId}/link`,
      participants
    );
  },
  getLinkedSubjectIDs({ studyId, ssuPatientId, itemGroupTemplateId, itemGroupTemplateVersionId, rowIds }) {
    return axios.post(
      `${ROOT}/studies/${studyId}/patients/${ssuPatientId}/item-groups/${itemGroupTemplateId}/${itemGroupTemplateVersionId}/linked-rows/participant-subject-ids`,
      rowIds
    );
  },
  unlinkParticipants({ studyId, ssuPatientId, itemGroupTemplateId, itemGroupTemplateVersionId, rowId, participants }) {
    return axios.post(
      `${ROOT}/studies/${studyId}/patients/${ssuPatientId}/item-groups/${itemGroupTemplateId}/${itemGroupTemplateVersionId}/logs/rows/${rowId}/unlink`,
      participants
    );
  },
  getLinkedParticipantForReview({
    studyId,
    ssuPatientId,
    itemGroupTemplateId,
    itemGroupTemplateVersionId,
    rowId,
    review
  }) {
    return axios.get(
      `${ROOT}/studies/${studyId}/patients/${ssuPatientId}/item-groups/${itemGroupTemplateId}/${itemGroupTemplateVersionId}/logs/rows/${rowId}/participants/review/${review}`
    );
  }
};

export default LogLinkApi;
